import React, { useState } from 'react';

const VideoList = ({
  videos,
  videoPage,
  videoTotalPages,
  videoLoading,
  loadMoreVideos,
  formatThumbnail,
  formatViews,
  getTimeAgo,
  isMobile = false
}) => {
  const [visibleCount, setVisibleCount] = useState(isMobile ? 4 : 6);

  const formatDuration = (secs) => {
    if (!secs) return "0:00";
    const minutes = Math.floor(secs / 60);
    const seconds = secs % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  const longVideos = videos.filter(v => v.type === 'long');
  const displayedVideos = longVideos.slice(0, visibleCount);

  const showLoadMoreButton = visibleCount < longVideos.length || videoPage < videoTotalPages;

  const handleLoadMore = () => {
    const increment = isMobile ? 4 : 6;
    const nextVisible = visibleCount + increment;
    setVisibleCount(nextVisible);
    if (nextVisible >= longVideos.length && videoPage < videoTotalPages) {
      loadMoreVideos();
    }
  };

  if (isMobile) {
    return (
      <div className="mt-1 md:mt-4 w-full flex flex-col items-center">
        {/* LONG VIDEOS GRID */}
        <div className="grid grid-cols-2 gap-x-3.5 gap-y-6 w-full">
          {displayedVideos.map((video) => (
            <a
              key={video._id}
              href={`https://vnd88video.com/watch/${video._id}`}
              target="_blank"
              rel="noopener noreferrer"
              className="flex flex-col gap-2 group"
            >
              <div className="relative aspect-video rounded-xl overflow-hidden shadow-lg bg-zinc-900">
                <img
                  src={formatThumbnail(video.thumbnailUrl)}
                  alt={video.title}
                  className="w-full h-full object-cover rounded-xl"
                  loading="lazy"
                />
                {video.duration > 0 && (
                  <span className="absolute bottom-2 right-2 bg-black/75 text-white text-[9px] px-1 py-0.5 rounded font-semibold">
                    {formatDuration(video.duration)}
                  </span>
                )}
              </div>
              <div className="flex flex-col gap-0.5 px-0.5">
                <h3 className="text-white font-bold text-[12px] line-clamp-2 leading-snug group-hover:text-[#EAC367] transition-colors">
                  {video.title}
                </h3>
                <p className="text-gray-400 text-[10px] font-medium mt-0.5">{video.admin?.fullname || "ALO8 Sự Kiện"}</p>
                <p className="text-gray-500 text-[9px]">
                  {formatViews(video.views)} lượt xem • {getTimeAgo(video.createdAt)}
                </p>
              </div>
            </a>
          ))}
        </div>

        {displayedVideos.length === 0 && (
          <div className="text-gray-400 text-center py-4 text-[13px]">Không có video nào được tìm thấy.</div>
        )}

        {/* LOAD MORE BUTTON FOR LONG VIDEOS */}
        {showLoadMoreButton && (
          <button
            onClick={handleLoadMore}
            disabled={videoLoading}
            className="mt-8 mb-3 px-8 py-2.5 bg-gradient-to-b from-[#25C4AF] via-[#25C4AF] to-[#009F8A] text-white rounded-full font-bold hover:opacity-90 transition-all shadow-lg disabled:opacity-50 text-[13px]"
          >
            {videoLoading ? "ĐANG TẢI..." : "XEM THÊM"}
          </button>
        )}
      </div>
    );
  }

  // DESKTOP VIEW
  return (
    <div className="mt-4 w-full flex flex-col items-center">
      {/* LONG VIDEOS GRID */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full">
        {displayedVideos.map((video) => (
          <a
            key={video._id}
            href={`https://vnd88video.com/watch/${video._id}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col gap-2.5 group"
          >
            <div className="relative aspect-video rounded-xl overflow-hidden shadow-lg bg-zinc-900">
              <img
                src={formatThumbnail(video.thumbnailUrl)}
                alt={video.title}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-103 rounded-xl"
                loading="lazy"
              />
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity bg-black/25">
                <svg className="w-12 h-12 text-white/90 drop-shadow-md" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
              {video.duration > 0 && (
                <span className="absolute bottom-2.5 right-2.5 bg-black/80 text-white text-[10.5px] px-2 py-0.5 rounded font-semibold tracking-wider">
                  {formatDuration(video.duration)}
                </span>
              )}
            </div>
            <div className="flex gap-3 px-1 mt-1">
              {video.admin?.avatarUrl && (
                <img
                  src={video.admin.avatarUrl}
                  alt={video.admin.fullname}
                  className="w-10 h-10 rounded-full object-cover border border-[#EAC367]/25 shrink-0"
                  loading="lazy"
                />
              )}
              <div className="flex flex-col gap-0.5">
                <h3 className="text-white font-bold text-[14.5px] line-clamp-2 leading-snug group-hover:text-[#EAC367] transition-colors">
                  {video.title}
                </h3>
                <p className="text-gray-400 text-[12px] font-medium mt-0.5">{video.admin?.fullname || "ALO8 Sự Kiện"}</p>
                <p className="text-gray-500 text-[11px]">
                  {formatViews(video.views)} lượt xem • {getTimeAgo(video.createdAt)}
                </p>
              </div>
            </div>
          </a>
        ))}
      </div>

      {displayedVideos.length === 0 && (
        <div className="text-gray-400 mt-10 text-center py-6">Không có video nào được tìm thấy.</div>
      )}

      {/* LOAD MORE BUTTON FOR LONG VIDEOS */}
      {showLoadMoreButton && (
        <button
          onClick={handleLoadMore}
          disabled={videoLoading}
          className="mt-12 px-10 py-3 bg-gradient-to-b from-[#25C4AF] via-[#25C4AF] to-[#009F8A] text-white rounded-full font-bold hover:opacity-90 transition-all shadow-lg disabled:opacity-50 text-[14px]"
        >
          {videoLoading ? "ĐANG TẢI..." : "XEM THÊM"}
        </button>
      )}
    </div>
  );
};

export default VideoList;
